import styled from '@emotion/styled'

export const Root = styled.div`
  display: flex;
  min-height: 100vh;
`
